if (!customElements.get('store-locator')) {
	const DISTRICT_NAMES = {
		capital: 'Capital District',
		eastern: 'Eastern Manila',
		camanava: 'CAMANAVA',
		southern: 'Southern Manila',
		nearby: 'Nearby provinces',
	};

	const distanceKm = (lat1, lng1, lat2, lng2) => {
		const rad = (d) => (d * Math.PI) / 180;
		const a =
			Math.sin(rad(lat2 - lat1) / 2) ** 2 +
			Math.cos(rad(lat1)) * Math.cos(rad(lat2)) * Math.sin(rad(lng2 - lng1) / 2) ** 2;
		return 6371 * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
	};

	class StoreLocator extends HTMLElement {
		connectedCallback() {
			this.cards = Array.from(this.querySelectorAll('.ksl-card'));
			this.list = this.querySelector('[data-list]');
			this.map = this.querySelector('[data-map]');
			this.search = this.querySelector('[data-search]');
			this.city = this.querySelector('[data-city]');
			this.count = this.querySelector('[data-count]');
			this.empty = this.querySelector('[data-empty]');
			this.near = this.querySelector('[data-near]');
			this.nearStatus = this.querySelector('[data-near-status]');
			this.chips = Array.from(this.querySelectorAll('.ksl-chip'));
			this.channel = 'all';

			const params = new URLSearchParams(window.location.search);
			this.district = DISTRICT_NAMES[params.get('district')] ? params.get('district') : '';
			if (params.get('city')) this.city.value = params.get('city');

			this.search.addEventListener('input', () => {
				// A name search looks across every store type and city.
				if (this.search.value.trim()) {
					this.setChannel('all');
					this.city.value = '';
					this.district = '';
				}
				this.filter();
			});
			this.city.addEventListener('change', () => {
				this.district = '';
				this.filter();
			});
			this.chips.forEach((chip) => {
				chip.addEventListener('click', () => {
					this.setChannel(chip.dataset.channel);
					this.filter();
				});
			});
			this.cards.forEach((card) => {
				card.querySelector('.ksl-card__select').addEventListener('click', () => this.select(card));
			});
			if (this.near) this.near.addEventListener('click', () => this.locate());
			this.filter();
			if (params.get('near') === '1') this.locate();
		}

		setChannel(channel) {
			this.channel = channel;
			this.chips.forEach((c) => {
				const active = c.dataset.channel === channel;
				c.classList.toggle('is-active', active);
				c.setAttribute('aria-pressed', active);
			});
		}

		setStatus(text) {
			if (!this.nearStatus) return;
			this.nearStatus.hidden = !text;
			this.nearStatus.innerHTML = text || '';
		}

		filter() {
			const term = this.search.value.trim().toLowerCase();
			const city = this.city.value;
			let visible = 0;
			this.cards.forEach((card) => {
				const show =
					(this.channel === 'all' || card.dataset.channel === this.channel) &&
					(!city || card.dataset.city === city) &&
					(!this.district || card.dataset.district === this.district) &&
					(!term || card.dataset.search.includes(term));
				card.hidden = !show;
				if (show) visible += 1;
			});
			this.count.textContent = visible;
			this.empty.hidden = visible > 0;
			if (this.district && !this.sorted) {
				this.setStatus(`Showing stores in <strong>${DISTRICT_NAMES[this.district]}</strong> · <button type="button" class="ksl-near__clear">Show all</button>`);
				const clear = this.nearStatus.querySelector('.ksl-near__clear');
				if (clear) clear.addEventListener('click', () => {
					this.district = '';
					this.setStatus('');
					this.filter();
				});
			}
		}

		locate() {
			if (!('geolocation' in navigator)) {
				this.setStatus('Location is not available on this device. Choose your city instead.');
				return;
			}
			this.near.classList.add('is-loading');
			this.setStatus('Finding stores near you…');
			navigator.geolocation.getCurrentPosition(
				(pos) => {
					this.near.classList.remove('is-loading');
					const { latitude, longitude } = pos.coords;
					this.cards.forEach((card) => {
						const km = distanceKm(latitude, longitude, parseFloat(card.dataset.lat), parseFloat(card.dataset.lng));
						card.dataset.km = km.toFixed(1);
						let badge = card.querySelector('.ksl-card__km');
						if (!badge) {
							badge = document.createElement('span');
							badge.className = 'ksl-card__km';
							card.querySelector('.ksl-card__select').prepend(badge);
						}
						badge.textContent = `≈ ${Math.max(1, Math.round(km))} km away`;
					});
					this.cards
						.slice()
						.sort((a, b) => parseFloat(a.dataset.km) - parseFloat(b.dataset.km))
						.forEach((card) => this.list.appendChild(card));
					this.sorted = true;
					this.district = '';
					this.city.value = '';
					this.filter();
					this.setStatus('Sorted by distance from your location (approximate, based on city).');
					const first = this.cards.find((c) => !c.hidden && this.list.firstElementChild === c) || this.list.querySelector('.ksl-card:not([hidden])');
					if (first) this.select(first);
				},
				() => {
					this.near.classList.remove('is-loading');
					this.setStatus('We could not get your location. Please allow location access or choose your city.');
				},
				{ enableHighAccuracy: false, timeout: 10000, maximumAge: 600000 }
			);
		}

		select(card) {
			this.cards.forEach((c) => c.classList.toggle('is-active', c === card));
			this.map.src = `https://maps.google.com/maps?q=${encodeURIComponent(card.dataset.query)}&z=16&output=embed`;
			if (window.matchMedia('(max-width: 989px)').matches) {
				this.map.scrollIntoView({ behavior: 'smooth', block: 'center' });
			}
		}
	}
	customElements.define('store-locator', StoreLocator);
}
